import {
  readImportHeadersFromFile,
  validateImportFile,
} from './providerImport.mjs'

export { readImportHeadersFromFile, validateImportFile }

export const CATEGORY_IMPORT_FIELDS = {
  externalCode: {
    key: 'externalCode',
    label: 'Внешний код',
    required: true,
  },
  name: {
    key: 'name',
    label: 'Название',
    required: true,
  },
  parentExternalCode: {
    key: 'parentExternalCode',
    label: 'Внешний код родителя',
    required: true,
  },
  code: {
    key: 'code',
    label: 'Внутренний код',
    required: false,
  },
  active: {
    key: 'active',
    label: 'Активна',
    required: false,
  },
}

export const CATEGORY_IMPORT_FIELD_LIST = Object.values(CATEGORY_IMPORT_FIELDS)
export const CATEGORY_IMPORT_PREVIEW_ENDPOINT = '/import/categories/preview'

export function getCategoryImportConfirmEndpoint(sessionId) {
  return `/import/categories/${encodeURIComponent(sessionId)}/confirm`
}

export async function previewCategoriesImport(apiClient, file, mapping) {
  const response = await apiClient.post(
    CATEGORY_IMPORT_PREVIEW_ENDPOINT,
    createCategoriesImportFormData(file, mapping)
  )
  return response.data
}

export async function confirmCategoriesImport(apiClient, sessionId) {
  const response = await apiClient.post(getCategoryImportConfirmEndpoint(sessionId))
  return response.data
}

export function isCategoryImportMappingComplete(mapping = {}) {
  return CATEGORY_IMPORT_FIELD_LIST
    .filter((field) => field.required)
    .every((field) => String(mapping[field.key] || '').trim() !== '')
}

export function createCategoriesImportFormData(file, mapping) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('mapping', JSON.stringify(mapping))
  return formData
}

export function isCategoryImportConfirmAllowed(preview, isSubmitting) {
  return Boolean(
    !isSubmitting &&
    preview?.sessionId &&
    preview?.status === 'ready' &&
    Number(preview?.summary?.errorCount || 0) === 0
  )
}

export function getCategoryImportPreviewSections(preview = {}) {
  const items = Array.isArray(preview.items) ? preview.items : []

  return {
    create: items.filter((item) => item.action === 'create'),
    update: items.filter((item) => item.action === 'update'),
    skipped: Array.isArray(preview.skipped) ? preview.skipped : [],
    errors: Array.isArray(preview.errors) ? preview.errors : [],
  }
}

export function formatCategoryImportError(error = {}) {
  const row = error.rowNumber ? `Рядок ${error.rowNumber} — ` : ''
  const field = error.field ? `${error.field}: ` : ''
  return `${row}${field}${error.message || 'Помилка'}`
}

export function extractCategoryImportConfirmResult(response = {}) {
  return response?.result || response || {}
}
